<script setup lang="ts">
  import { useWindowSize } from '@/composables/useWindowSize'
  import { Execution } from '@/shared/Executions/models/Execution'
  import { getLocalizedDateTimeString2 } from '@/utils'
  import { Calendar } from 'lucide-vue-next'

  const { isMediumTierOrLess } = useWindowSize()

  const props = defineProps<{
    record: Execution
    index?: number
    selectable?: boolean
    onCellClick?: (record: Execution, e?: Event) => void
  }>()

  function handleClick(e?: Event) {
    if (props.selectable && props.onCellClick) {
      props.onCellClick(props.record, e)
    }
  }
</script>

<template>
  <div :class="[{ 'cursor-pointer': selectable }]" @click="handleClick">
    <div v-if="!isMediumTierOrLess">
      <span role="end-time">
        {{ getLocalizedDateTimeString2(record.createdUtc, record.createdUtc) }}
      </span>
    </div>
    <div v-else>
      <span role="end-time">
        <Calendar />
      </span>
    </div>
  </div>
</template>
